import { ActiveScriptState } from '@/store/modules/active-script/state'
import { ScriptEditState } from '@/store/modules/script-edit/state'
import { ScriptPageState } from '@/store/modules/script-page/state'
import { ScriptUnit, ScriptInstance } from '@/models/scripts'
import { Scheme } from '@/models/scheme'

export interface ScriptsState {
  list: ScriptUnit[]
  scheme: Scheme
  sortAsc: boolean
  sortColumn: keyof ScriptUnit | keyof ScriptInstance
  activeScript?: ActiveScriptState
  scriptEdit?: ScriptEditState
  scriptPage?: ScriptPageState
}

export const initialState: ScriptsState = {
  list: [],
  sortAsc: true,
  sortColumn: 'title',
  scheme: {
    update: 0,
    root: null,
    depth: 0,
    cards: [],
    numsIds: new Map(),
    map: {},
  },
}
